import AuthLayout from 'layout/Auth';
import { lazy } from 'react';
import Loadable from 'components/Loadable';
import GuestGuard from 'utils/route-guard/GuestGuard';

const Login = Loadable(lazy(() => import('pages/login')));
const ForgotPassword = Loadable(lazy(() => import('pages/forgot-password')));

const LoginRoutes = {
  path: '/auth',
  element: <GuestGuard><AuthLayout /></GuestGuard>,
  children: [
    {
      path: 'login',
      element: <Login />
    },
    {
      path: 'forgot-password',
      element: <ForgotPassword />
    }
  ]
};

export default LoginRoutes;
